<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>{{$route.query.title}}</p>
    </div>
    <div class="panel-content center_content">
      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">姓名</th>
              <th class="itemStatus">实验结果</th>
              <th class="itemStatus">实验成绩</th>
              <th class="itemStatus">实验开始时间</th>
              <th class="itemStatus">实验结束时间</th>
              <th class="itemStatus">实验用时</th>
              <th
                class="action"
                width="130"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in tableData"
              :key="item.id"
            >
              <td class="itemStatus">{{item.experimentStudent.userprofile.name}}</td>
              <td class="itemStatus">{{item.status?'完成':'未完成'}}</td>
              <td class="itemStatus">{{item.score}}</td>
              <td class="itemStatus">{{formatTime(item.startTime)}}</td>
              <td class="itemStatus">{{formatTime(item.endTime)}}</td>
              <td class="itemStatus">{{secondsToMinute(item.timeUsed)}}分钟</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="viewDetail(item)"
                >查看详情</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="!tableData.length"
        >没有数据</div>

      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
      <div class="tips">
        <div>缺省提示：</div>
        <div>您的课程与实验空间完成接口对接后，可在此查看学生的实验成绩</div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="classShowWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel form_panel_item">
        <div class="form_title">详情
          <span @click="classShowWindow={}">X</span>
        </div>
        <div class="form_content">
          <div class="experiment_text">
            <p>姓名：{{experimentGrade && experimentGrade.experimentStudent ? experimentGrade.experimentStudent.userprofile.name : ''}}</p>
            <p><span>实验开始时间：{{formatTime(experimentGrade.startTime)}}</span>
              <span>实验结束时间：{{formatTime(experimentGrade.endTime)}}</span>
              <span>实验用时：{{secondsToMinute(experimentGrade.timeUsed)}}分钟</span>
            </p>
            <p><span>实验满分：100</span>
              <span>实验得分：{{experimentGrade.score}}</span>
              <span>实验结果：{{experimentGrade.status?'完成':'未完成'}}</span>
            </p>
          </div>
          <div class="f_list">
            <table>
              <tbody>
                <tr class="l_header">
                  <th class="itemStatus">步骤名称</th>
                  <th class="itemStatus">步骤开始时间</th>
                  <th class="itemStatus">步骤结束时间</th>
                  <th class="itemStatus">步骤用时</th>
                  <th class="itemStatus">步骤合理用时</th>
                  <th class="itemStatus">步骤满分</th>
                  <th class="itemStatus">步骤得分</th>
                  <th class="itemStatus">步骤操作次数</th>
                  <th class="itemStatus">步骤评价</th>
                  <th class="itemStatus">赋分模型</th>
                  <th class="itemStatus">备注</th>
                </tr>
                <tr
                  class="item"
                  v-for="item in tableStepData"
                  :key="item.id"
                >
                  <td class="itemStatus">{{item.title}}</td>
                  <td class="itemStatus">{{formatTime(item.startTime)}}</td>
                  <td class="itemStatus">{{formatTime(item.endTime)}}</td>
                  <td class="itemStatus">{{secondsToMinute(item.timeUsed)}}分钟</td>
                  <td class="itemStatus">{{secondsToMinute(item.expectTime)}}分钟</td>
                  <td class="itemStatus">{{item.maxScore}}</td>
                  <td class="itemStatus">{{item.score}}</td>
                  <td class="itemStatus">{{item.repeatCount}}</td>
                  <td class="itemStatus">{{item.evaluation}}</td>
                  <td class="itemStatus">{{item.scoringModel}}</td>
                  <td class="itemStatus">{{item.remarks}}</td>
                </tr>
              </tbody>
            </table>
            <div
              class="noitems"
              v-if="!tableStepData.length"
            >没有数据</div>
          </div>
          <div class="f_list" v-if="experimentGrade.remarks" v-html="experimentGrade.remarks"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'User',
  components: {
    Pagination
  },
  data() {
    return {
      classShowWindow: {},
      tableData: [],
      tableDataCount: 0,
      tableStepData: [],
      tableStepDataCount: 0,
      queryInfo: {
        page: 1,
        size: 10,
        experiment_id: this.$route.query.experiment_id
      },
      experimentGrade: {}
    }
  },
  methods: {
    secondsToMinute(s) {
      if (!s) {
        return 0
      }
      return Math.ceil(s / 60)
    },
    async viewDetail(item) {
      this.experimentGrade = item
      this.classShowWindow = {
        visibility: 'visible'
      }
      const params = {
        page: 1,
        size: 10000,
        experimentGrade_id: item.id
      }

      await this.$http.get('/experimentstep/', { params }).then((data) => {
        this.tableStepData = data.results
        this.tableStepDataCount = data.count
      }).catch(() => {
        this.$parent.showMsg('获取轮播信息失败！')
      })
    },
    formatTime(val) {
      return val ? val.replace('T', ' ') : '--'
    },
    // 搜索
    async search() {
      await this.$http.get('/experimentgrade/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$parent.showMsg('获取轮播信息失败！')
      })
    },

    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
.tips {
  clear: both;
  color: #999;
}
.form_panel_item {
  width: 1200px;
  max-width: none;
  margin: 0;
  transform: translate(-50%, -50%);
}
.f_list .l_header th {
  padding: 15px 0;
}
.experiment_text {
  margin-bottom: 20px;
}
.experiment_text p {
  line-height: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.experiment_text p span {
  flex: 1;
}
.form_title {
  position: relative;
}
.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  color: #999;
  font-weight: normal;
  cursor: pointer;
}
</style>
